import './Authors.css';
import authors from '../../assets/constants/authors'
import {Link} from 'react-router-dom'
import React from "react";
import Footer from '../Footer';

function Authors(props) {

    return (
        <div className="brands">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
            <Link className="link" to="/stories" >
                <p className="backButton secondBackButton"> back to all stories </p>
            </Link>
            <h1 className="brandHeaderText"> Authors </h1>
            <div className="row authorList">
            {authors.map((author, index) => (
                <div className="authorRectangleDiv">
                    <p className="authorText"> {author.name}</p>
                    <p className="authorText titleText"> {author.title}</p>
                </div>
            ))}
            </div>
            <Footer/>
        </div>

    )

}

export default Authors;